import React from 'react';  

import {
    withStyles,
    Grid,
    Typography,
    Avatar,
    ButtonBase,
    withRouter
} from '../../material-ui';

import MBackIcon from '../view/MBackIcon';
import DefaultAvatarImg from '../../images/change/default_avatar.png';
import AppData from '../../model/AppData';
import CoinIcon from '../../images/mine/qiubi.png';

const SHOP_CONFIG = [
    {
        coin: 42, rmb: '6.00',
        isSelect: true,
    },
    {
        coin: 210, rmb: '30.00',
        isSelect: false,
    },
    {
        coin: 686, rmb: '98.00',
        isSelect: false,
    },
    {
        coin: 2086, rmb: '298.00',
        isSelect: false,
    },
    {
        coin: 3626, rmb: '518.00',
        isSelect: false,
    },
    {
        coin: 11186, rmb: '1598.00',
        isSelect: false,
    },
];

class ShopDialog extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            avatar: AppData.me.Pic,
            selectIndex: 0,
        };
        this._onPayClick = this._onPayClick.bind(this);
        this._onListItemClick = this._onListItemClick.bind(this);

    }

    _onPayClick() {

    }

    _onListItemClick(n) {
        console.log("选择测试", n)
        // SHOP_CONFIG.forEach((data)=>{
        //     data.isSelect = false;
        // })
        // SHOP_CONFIG[n].isSelect = true;
        this.setState({ selectIndex: n });
    }

    render() {
        const { classes } = this.props;
        const { selectIndex } = this.state;
        let shop_config = SHOP_CONFIG;
        return (
            <Grid style={{ height: '100vh', backgroundColor: '#FFFFFF' }}>
                <Grid container className={classes.img} justify="center" alignItems="center">
                    <Grid container direction='row' style={{ height: 20 }}></Grid>
                    <Grid container justify="center">
                        <MBackIcon className={classes.root} />
                        <Typography className={classes.titleText}>我的球币</Typography>
                    </Grid>
                    <Grid container className={classes.boxinfo} justify="center" >
                        <Avatar className={classes.avatar} src={this.state.avatar} />
                        <Grid container justify="center">
                            <Typography style={{ color: "#0D0D0D", fontSize: 36.2, marginLeft: 12 }}> 100 </Typography>
                            <img src={CoinIcon} style={{ width: 16, height: 16 }}></img>
                        </Grid>
                        <Grid container alignItems="flex-start" justify="center" style={{ marginTop: -20 }}>
                            <Typography style={{ color: "#898989", fontSize: 10 }}> 我的球币 </Typography>
                        </Grid>
                    </Grid>


                </Grid>

                <Grid container justify="flex-start" style={{ marginLeft: 10, marginTop: 30 }}>
                    <Typography style={{ color: "#898989", fontSize: 10 }}> 充值即代表同意《球求播充值协议》 </Typography>
                </Grid>
                <Grid container justify="flex-start" style={{ marginLeft: 10, marginTop: 10 }}>
                    <Grid container alignItems="center" justify="center">
                        {
                            shop_config.map((data, n) => (
                                <Grid container key={n + ''} className={classes.cellbg1} style={{ backgroundColor: '#FFE5DD', marginRight: 15, marginBottom: 10, background: selectIndex == n ? 'linear-gradient(to right, #ED8B5B, #F64152)' : '#FFE5DD' }}
                                    onClick={() => this._onListItemClick(n)}>
                                    <Grid container justify="center">
                                        <Typography style={{ color: selectIndex == n ? '#FFFFFF' : "#F16957", fontSize: 26, fontWeight: 'bolder' }}> {data.coin} </Typography>
                                        <Typography style={{ color: selectIndex == n ? '#FFFFFF' : "#F16957", fontSize: 3, writingMode: 'vertical-lr', marginTop: 10 }}> 球币 </Typography>
                                    </Grid>
                                    <Grid container className={classes.cellbg2} justify="center" alignItems="center" style={{ backgroundColor: '#FFFFFF' }}>
                                        <Typography style={{ color: "#898989", fontSize: 10 }}> {data.rmb}元 </Typography>
                                    </Grid>
                                </Grid>
                            ))
                        }
                    </Grid>
                </Grid>
                <Grid container justify="flex-start" alignItems="center" style={{ borderTop: "ridge", backgroundColor: '#FFFFFF', width: '100%', height: 59.5, position: 'fixed', bottom: 0 }}>
                    <Typography style={{ color: "#0E0E0E", fontSize: 13, marginLeft: 20 }}> 总计: </Typography>
                    <Typography style={{ color: "#EF7B59", fontSize: 13 }}> {shop_config[this.state.selectIndex].rmb}元 </Typography>
                    <ButtonBase
                        className={classes.sureBtn}
                        onClick={() => this._onPayClick()}
                    >确定支付</ButtonBase>
                </Grid>
            </Grid>
        );
    }
}

export default withRouter(withStyles((theme) => (
    {
        root: {
            color: '#FFFFFF',
        },
        sureBtn: {
            background: 'linear-gradient(to right, #ED8B5B, #F64152)',
            borderRadius: 10.5,
            color: '#FFFFFF',
            height: 35,
            width: 107,
            position: 'fixed',
            right: 15,
            // margin: theme.spacing(1.3, 0, 0, 0),
            fontSize: 14,
            // fontWeight: theme.typography.fontWeightBold,
        },
        appbar: {
            backgroundColor: '#FFF',
            flexDirection: 'rows',
            boxShadow: '1px 1px 3px #F0F0F0',
            marginTop: 0,
        },
        titleText: {
            fontSize: 17,
            color: '#FFFFFF',
            margin: theme.spacing(1.5, 0, 0, 0),
        },
        img: {
            width: '100%',
            height: 180,
            background: 'linear-gradient(to right, #ED8B5B, #F64152)',
        },
        boxinfo: {
            width: 355,
            height: 111,
            background: '#FFFFFF',
            borderRadius: 10.5,
            margin: theme.spacing(4.2, 0, 0, 0),
            borderBottom: "inset",
        },
        avatar: {
            width: 40,
            height: 40,
            color: '#fff',
            backgroundSize: 'cover',
            backgroundImage: `url(${DefaultAvatarImg})`,
            margin: theme.spacing(-2.5, 0, 0, 0),
        },
        cellbg1: {
            width: 106,
            height: 70,
            border: "solid 1px #FFC6B6",
            borderRadius: 10.5,
            alignItems: 'flex-end',
        },
        cellbg2: {
            width: 106,
            height: 25,
            // borderRadius: 10.5,
            borderBottomLeftRadius: 10.5,
            borderBottomRightRadius: 10.5,
            // borderBottomLeft:10.5,
        },
    }
))(ShopDialog));